const etfs = [
  {
    name: 'SPDR S&P 500',
    price: 420.69,
    performance: 12.3,
    volatility: 14.2,
    dividendYield: 1.8,
    TER: 0.09,
    issuer: 'SPDR',
    region: 'Monde',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Tous secteurs',
    availability: 'Partout',
    volume: 5000000,
    inceptionDate: '1993-01-22',
    currentPrice: 422.50,
    previousClose: 420.00,
  },
  {
    name: 'iShares MSCI Europe',
    price: 85.20,
    performance: 8.1,
    volatility: 12.1,
    dividendYield: 2.5,
    TER: 0.15,
    issuer: 'iShares',
    region: 'Europe',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Tous secteurs',
    availability: 'Europe',
    volume: 1200000,
    inceptionDate: '2000-05-15',
    currentPrice: 84.50,
    previousClose: 85.00,
  },
  {
    name: 'Vanguard Technology ETF',
    price: 150.55,
    performance: 18.5,
    volatility: 20.3,
    dividendYield: 0.7,
    TER: 0.12,
    issuer: 'Vanguard',
    region: 'USA',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Technologie',
    availability: 'USA',
    volume: 3500000,
    inceptionDate: '2010-03-10',
    currentPrice: 153.00,
    previousClose: 150.00,
  },
  {
    name: 'Lyxor Healthcare',
    price: 100.30,
    performance: 10.2,
    volatility: 13.5,
    dividendYield: 2.0,
    TER: 0.18,
    issuer: 'Lyxor',
    region: 'Europe',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Santé',
    availability: 'Europe',
    volume: 900000,
    inceptionDate: '2005-08-25',
    currentPrice: 100.50,
    previousClose: 101.00,
  },
  {
    name: 'Amundi Energy',
    price: 48.90,
    performance: 4.5,
    volatility: 16.7,
    dividendYield: 3.2,
    TER: 0.20,
    issuer: 'Amundi',
    region: 'Monde',
    type: 'Hybride',
    replication: 'Physique',
    sector: 'Énergie',
    availability: 'Partout',
    volume: 800000,
    inceptionDate: '2012-06-01',
    currentPrice: 49.10,
    previousClose: 48.80,
  },
  {
    name: 'Xtrackers Financials',
    price: 75.80,
    performance: 6.7,
    volatility: 11.4,
    dividendYield: 2.7,
    TER: 0.13,
    issuer: 'Xtrackers',
    region: 'Europe',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Finance',
    availability: 'Europe',
    volume: 1500000,
    inceptionDate: '2008-09-12',
    currentPrice: 75.30,
    previousClose: 75.00,
  },
  {
    name: 'Invesco Real Estate',
    price: 110.40,
    performance: 9.1,
    volatility: 10.9,
    dividendYield: 3.5,
    TER: 0.22,
    issuer: 'Invesco',
    region: 'USA',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Immobilier',
    availability: 'USA',
    volume: 1800000,
    inceptionDate: '2011-11-20',
    currentPrice: 111.00,
    previousClose: 110.50,
  },
  {
    name: 'Global Industrials ETF',
    price: 130.75,
    performance: 7.9,
    volatility: 13.0,
    dividendYield: 2.1,
    TER: 0.14,
    issuer: 'GlobalFunds',
    region: 'Monde',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Industrie',
    availability: 'Partout',
    volume: 2200000,
    inceptionDate: '2003-04-18',
    currentPrice: 131.00,
    previousClose: 130.00,
  },
  {
    name: 'Emerging Markets ETF',
    price: 60.15,
    performance: 11.0,
    volatility: 21.5,
    dividendYield: 1.4,
    TER: 0.25,
    issuer: 'EmergingFunds',
    region: 'Asie',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Tous secteurs',
    availability: 'Asie',
    volume: 1000000,
    inceptionDate: '2014-02-07',
    currentPrice: 60.00,
    previousClose: 60.10,
  },
  {
    name: 'S&P Dividend ETF',
    price: 95.10,
    performance: 5.5,
    volatility: 9.5,
    dividendYield: 4.1,
    TER: 0.10,
    issuer: 'SPDR',
    region: 'Monde',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Tous secteurs',
    availability: 'Partout',
    volume: 2500000,
    inceptionDate: '1998-07-01',
    currentPrice: 95.50,
    previousClose: 95.00,
  },
  {
    name: 'Tech Leaders ETF',
    price: 140.20,
    performance: 15.8,
    volatility: 18.7,
    dividendYield: 0.6,
    TER: 0.11,
    issuer: 'TechFunds',
    region: 'USA',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Technologie',
    availability: 'USA',
    volume: 2700000,
    inceptionDate: '2013-09-05',
    currentPrice: 140.50,
    previousClose: 139.50,
  },
  {
    name: 'European Financial ETF',
    price: 70.30,
    performance: 6.2,
    volatility: 11.0,
    dividendYield: 2.8,
    TER: 0.14,
    issuer: 'EuroFunds',
    region: 'Europe',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Finance',
    availability: 'Europe',
    volume: 1300000,
    inceptionDate: '2006-10-23',
    currentPrice: 70.00,
    previousClose: 70.10,
  },
  {
    name: 'Global Health ETF',
    price: 105.00,
    performance: 9.9,
    volatility: 12.2,
    dividendYield: 2.9,
    TER: 0.16,
    issuer: 'GlobalFunds',
    region: 'Monde',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Santé',
    availability: 'Partout',
    volume: 2100000,
    inceptionDate: '2007-12-11',
    currentPrice: 105.50,
    previousClose: 105.00,
  },
  {
    name: 'Energy Plus ETF',
    price: 55.25,
    performance: 3.8,
    volatility: 17.4,
    dividendYield: 3.0,
    TER: 0.19,
    issuer: 'EnergyFunds',
    region: 'Monde',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Énergie',
    availability: 'Partout',
    volume: 900000,
    inceptionDate: '2015-05-30',
    currentPrice: 54.90,
    previousClose: 55.00,
  },
  {
    name: 'Real Estate Leaders',
    price: 115.60,
    performance: 7.1,
    volatility: 10.5,
    dividendYield: 3.3,
    TER: 0.21,
    issuer: 'RealFunds',
    region: 'USA',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Immobilier',
    availability: 'USA',
    volume: 1400000,
    inceptionDate: '2012-07-19',
    currentPrice: 116.00,
    previousClose: 115.50,
  },
  {
    name: 'Industrial Growth ETF',
    price: 125.80,
    performance: 8.4,
    volatility: 13.7,
    dividendYield: 2.2,
    TER: 0.15,
    issuer: 'IndusFunds',
    region: 'Monde',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Industrie',
    availability: 'Partout',
    volume: 2000000,
    inceptionDate: '2004-03-10',
    currentPrice: 126.50,
    previousClose: 125.00,
  },
  {
    name: 'Asia Pacific ETF',
    price: 65.40,
    performance: 10.5,
    volatility: 16.8,
    dividendYield: 1.9,
    TER: 0.17,
    issuer: 'AsiaFunds',
    region: 'Asie',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Tous secteurs',
    availability: 'Asie',
    volume: 1100000,
    inceptionDate: '2010-01-21',
    currentPrice: 65.00,
    previousClose: 65.20,
  },
  {
    name: 'Dividend Growth ETF',
    price: 90.50,
    performance: 6.0,
    volatility: 9.0,
    dividendYield: 3.7,
    TER: 0.12,
    issuer: 'DividendFunds',
    region: 'Monde',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Tous secteurs',
    availability: 'Partout',
    volume: 1800000,
    inceptionDate: '2001-08-29',
    currentPrice: 90.70,
    previousClose: 90.40,
  },
  {
    name: 'Tech Innovators',
    price: 145.90,
    performance: 17.2,
    volatility: 19.8,
    dividendYield: 0.5,
    TER: 0.10,
    issuer: 'TechFunds',
    region: 'USA',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Technologie',
    availability: 'USA',
    volume: 2800000,
    inceptionDate: '2014-04-07',
    currentPrice: 146.50,
    previousClose: 145.00,
  },
  {
    name: 'European Energy ETF',
    price: 50.10,
    performance: 4.1,
    volatility: 15.6,
    dividendYield: 3.1,
    TER: 0.20,
    issuer: 'EuroEnergy',
    region: 'Europe',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Énergie',
    availability: 'Europe',
    volume: 850000,
    inceptionDate: '2009-02-14',
    currentPrice: 50.00,
    previousClose: 50.20,
  },
  {
    name: 'Global Finance ETF',
    price: 72.80,
    performance: 7.0,
    volatility: 11.7,
    dividendYield: 2.6,
    TER: 0.13,
    issuer: 'GlobalFunds',
    region: 'Monde',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Finance',
    availability: 'Partout',
    volume: 1600000,
    inceptionDate: '2003-11-05',
    currentPrice: 73.00,
    previousClose: 72.50,
  },
  {
    name: 'Healthcare Innovators',
    price: 108.70,
    performance: 10.8,
    volatility: 12.5,
    dividendYield: 3.0,
    TER: 0.15,
    issuer: 'HealthFunds',
    region: 'Monde',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Santé',
    availability: 'Partout',
    volume: 2300000,
    inceptionDate: '2008-08-30',
    currentPrice: 109.00,
    previousClose: 108.50,
  },
  {
    name: 'Energy Sector Leaders',
    price: 58.20,
    performance: 5.2,
    volatility: 16.1,
    dividendYield: 3.4,
    TER: 0.18,
    issuer: 'EnergyFunds',
    region: 'Monde',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Énergie',
    availability: 'Partout',
    volume: 1000000,
    inceptionDate: '2011-01-12',
    currentPrice: 58.00,
    previousClose: 58.30,
  },
  {
    name: 'Real Estate Income',
    price: 120.45,
    performance: 6.9,
    volatility: 10.3,
    dividendYield: 3.8,
    TER: 0.22,
    issuer: 'RealFunds',
    region: 'USA',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Immobilier',
    availability: 'USA',
    volume: 1250000,
    inceptionDate: '2013-06-18',
    currentPrice: 120.80,
    previousClose: 120.00,
  },
  {
    name: 'Industrial Leaders ETF',
    price: 128.30,
    performance: 8.1,
    volatility: 14.0,
    dividendYield: 2.0,
    TER: 0.16,
    issuer: 'IndusFunds',
    region: 'Monde',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Industrie',
    availability: 'Partout',
    volume: 2100000,
    inceptionDate: '2005-09-28',
    currentPrice: 128.00,
    previousClose: 128.50,
  },
  {
    name: 'Asia Growth ETF',
    price: 68.90,
    performance: 12.4,
    volatility: 18.3,
    dividendYield: 1.7,
    TER: 0.19,
    issuer: 'AsiaFunds',
    region: 'Asie',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Tous secteurs',
    availability: 'Asie',
    volume: 1150000,
    inceptionDate: '2011-12-02',
    currentPrice: 69.20,
    previousClose: 68.80,
  },
  {
    name: 'Dividend Select ETF',
    price: 92.10,
    performance: 5.8,
    volatility: 9.8,
    dividendYield: 3.6,
    TER: 0.13,
    issuer: 'DividendFunds',
    region: 'Monde',
    type: 'Capitalisation',
    replication: 'Synthétique',
    sector: 'Tous secteurs',
    availability: 'Partout',
    volume: 1750000,
    inceptionDate: '2002-07-14',
    currentPrice: 92.50,
    previousClose: 91.80,
  },
  {
    name: 'Tech Growth ETF',
    price: 147.50,
    performance: 16.7,
    volatility: 20.0,
    dividendYield: 0.4,
    TER: 0.10,
    issuer: 'TechFunds',
    region: 'USA',
    type: 'Accumulation',
    replication: 'Physique',
    sector: 'Technologie',
    availability: 'USA',
    volume: 3000000,
    inceptionDate: '2015-03-25',
    currentPrice: 147.00,
    previousClose: 146.50,
  }
]

export default etfs;
